module.exports = __webpack_public_path__ + "static/img/2.80504cd9.png";